import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { AttributeOverviewComponent } from './attribute-overview/attribute-overview.component';
import { AuthInfoService } from '../../core/auth-info/auth-info.service';
import { resolveAuthInfo } from '../../core/auth-info/auth-info.resolver';

export const ATTRIBUTE_STATES: Ng2StateDeclaration[] = [
  {
    name: 'app.settings.attribute',
    redirectTo: 'app.settings.attribute.overview',
    url: '/attribute',
    params: {
      security: {
        enabled: true,
        roles: [],
      },
      style: {
        feedback: true,
        hasMainMenu: true,
        hasSubMenu: true,
        hasSideNav: false,
      },
    },
    resolve: [
      {
        token: 'authInfo',
        deps: [AuthInfoService],
        resolveFn: resolveAuthInfo,
      },
    ],
  },
  {
    name: 'app.settings.attribute.overview',
    views: {
      '$default@app': {
        component: AttributeOverviewComponent,
      },
    },
    url: '/',
  },
];
